import { X, ArrowUp } from "lucide-react";
import { imgUrl } from "@/lib/api";
import { UploadButton } from "@/admin/Upload";

const uid = () => Math.random().toString(36).slice(2, 12);

export function ImageField({ value, onChange }) {
  return (
    <div className="flex items-start gap-4" data-testid="image-field">
      {value ? <img src={imgUrl(value)} alt="" className="w-28 h-20 object-cover border border-[#e2dcd4]" /> : <div className="w-28 h-20 bg-[#f4f0ea] border border-dashed border-[#e2dcd4]" />}
      <div className="flex-1 space-y-2">
        <UploadButton onUploaded={(url) => onChange(url)} label="Upload image" testid="cover-upload-button" />
        <input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="…or paste an image URL"
          className="w-full border border-[#e2dcd4] px-3 py-2 text-xs" data-testid="cover-url-input" />
      </div>
    </div>
  );
}

export function ImagesField({ value = [], onChange }) {
  const update = (i, patch) => onChange(value.map((im, j) => (j === i ? { ...im, ...patch } : im)));
  const remove = (i) => onChange(value.filter((_, j) => j !== i));
  const toTop = (i) => onChange([value[i], ...value.filter((_, j) => j !== i)]);

  return (
    <div className="space-y-3" data-testid="images-field">
      <UploadButton multiple label="Upload photographs"
        onUploaded={(url, f) => onChange((value = [...value, { id: uid(), url, caption: f.name.replace(/\.[^.]+$/, "") }]))}
        testid="gallery-images-upload-button" />
      {value.length === 0 && <p className="text-xs text-[#5a665e]">No photographs yet.</p>}
      <div className="grid gap-2">
        {value.map((im, i) => (
          <div key={im.id || i} className="flex items-center gap-3 border border-[#e2dcd4] bg-white p-2" data-testid={`gallery-image-row-${i}`}>
            <img src={imgUrl(im.url)} alt="" className="w-16 h-12 object-cover" />
            <input value={im.caption || ""} onChange={(e) => update(i, { caption: e.target.value })} placeholder="Caption"
              className="flex-1 border border-[#e2dcd4] px-2 py-1.5 text-sm" data-testid={`gallery-image-caption-${i}`} />
            <button type="button" onClick={() => toTop(i)} title="Move to top" className="p-1.5 text-[#5a665e] hover:text-[#1f402b]" data-testid={`gallery-image-top-${i}`}><ArrowUp size={14} /></button>
            <button type="button" onClick={() => remove(i)} title="Remove" className="p-1.5 text-[#991b1b]" data-testid={`gallery-image-remove-${i}`}><X size={14} /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
